import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NumpadComponent } from "./numpad.component";

@NgModule({
  declarations: [
    NumpadComponent,
  ],
  exports: [
    NumpadComponent,
    CommonModule
  ],
  imports:[
    CommonModule
  ]
})
export class NumpadModule { }
